import React from 'react';
import { Link } from 'react-router-dom';

export default function Landing() {
  return (
    <div className="landing">
      <div className="landing-hero">
        <img src="/sanctuary.jpg" alt="St. John's Church" className="landing-hero-img" />
        <div className="landing-hero-overlay" />
      </div>
      <div className="landing-content">
        <h1>
          Welcome to <span>St. John's</span>
        </h1>
        <p className="landing-subtitle">
          Report a property need for the Church or the Pastor's House, or see what the Trustees are working on.
        </p>
        <div className="landing-actions">
          <Link to="/submit" className="btn btn-primary">
            Submit a Request
          </Link>
          <Link to="/board" className="btn btn-secondary">
            View the Board
          </Link>
        </div>
      </div>
    </div>
  );
}
